import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteAssetMutationAtom = createMutationAtomFactory(
  'transportation.assetDelete',
  (params: { id: string }) => ({
    transportationAssetDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
